import gatewayService from '@/modules/common/services/gatewayService';

const baseRoute = '/v3/license';

const fetchQuotaBalances = async ({ sku } = {}) => {
  const query = sku ? `?sku=${encodeURIComponent(sku)}` : '';
  const response = await gatewayService.get(`${baseRoute}/quota_balances${query}`);

  return {
    balances: response?.data?.data?.quota_balances || [],
    totals: response?.data?.meta?.totals || [],
  };
};

export default { fetchQuotaBalances };
